module.exports = __webpack_public_path__ + "static/media/20ECE24.96524f0a.jpg";